import * as React from 'react';
import PropTypes from 'prop-types';

const HeartOutline = ({ color = '#fff', fillColor = '#F7988B', strokeWidth = 1.4, filled = false, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill={filled ? fillColor : 'none'} {...props}>
    <path
      stroke={filled ? fillColor : color}
      strokeWidth={strokeWidth}
      d="M12.0034 5.99871C6.60223 -2.91568 -7.51326 10.3121 12.0034 20.9394C31.52 10.3121 17.3795 -2.91568 12.0034 5.99871Z"
      clipRule="evenodd"
    />
  </svg>
);

HeartOutline.propTypes = {
  color: PropTypes.string,
  fillColor: PropTypes.string,
  strokeWidth: PropTypes.number,
  filled: PropTypes.bool
};

export default HeartOutline;
